<template>
  <el-form
    ref="mergeDataForm"
    :model="model"
    :rules="rules"
    label-width="12em"
    label-position="left"
    class="merge-data-form"
  >
    <div class="el-form--inline">
    <BillingYm v-model="billingYm" :required="true" :disabled="editMode || editDisabledMode" :mode="billingYmMode" :autofocus="!editMode" :searchCond="searchMode" :actualprop=true />

      <template v-if='formMode === "search"'>
        <div class="parent_Box">
          <div class="child_Box">
            <el-checkbox v-model="errorDataOnly" v-if="searchMode" :disabled="editDisabledMode" :searchCond="searchMode" >検索結果にエラーデータのみ表示する</el-checkbox>
          </div>
          <div class="child_Box">
            <el-checkbox v-model="calculateAllData" v-if="searchMode" :disabled="editDisabledMode" :searchCond="searchMode" >検索結果に計算対象データを表示する</el-checkbox>
          </div>
          <div class="child_Box">
            <el-checkbox v-model="billingExclusionDataOnly" v-if="searchMode" :disabled="editDisabledMode" :searchCond="searchMode" >検索結果に請求除外データのみ表示する</el-checkbox>
          </div>
        </div>
      </template>
      <template v-else>
        <Blank />
      </template>
    </div>
    <el-divider />
    <div class="el-form--inline">
      <ActionType v-model="actionType" label="着離陸・入出庫区分" :required="!searchMode"
      :disabled="editMode || editDisabledMode" mode="normal" @change="changeActionType($event)"/>
      <RegistrationSymbol v-model="registrationSymbol" :required="!searchMode" :searchCond="searchMode"
      :disabled="editMode || editDisabledMode" :autocomplete-list="autocompleteRegistrationSymbolSet" />
    </div>
    <template v-if='formMode === "search"'>
      <DateTimeRange :dateTimeFrom.sync="actionTimeFrom" :dateTimeTo.sync="actionTimeTo" label="着離陸・入出庫日時"
        :required="!searchMode" :searchCond="searchMode" :disabled="editMode || editDisabledMode" />
    </template>
    <template v-else>
      <div class="el-form--inline">
        <DateTime v-model="actionTime" label="着離陸・入出庫日時" prop="action_time"
          :required="!searchMode" :searchCond="searchMode" mode="normal" :disabled="editMode || editDisabledMode" />
        <template v-if='(actionType === "1" || actionType === "8")'>
          <template v-if='(actionType === "1")'>
            <BillingExclusion v-model="billingExclusion" label="着陸請求除外" prop="billing_exclusion_flag" :initialize="true" :disabled="editDisabledMode"
              placeholder="請求除外時のみ選択" :clearable="true" codeId="BILLING_EXCLUSION_ARR"/>
          </template>
          <template v-if='(actionType === "8")'>
            <BillingExclusion v-model="billingExclusion" label="離陸請求除外" prop="billing_exclusion_flag" :initialize="true" :disabled="editDisabledMode"
              placeholder="請求除外時のみ選択" :clearable="true" codeId="BILLING_EXCLUSION_DEP"/>
          </template>
        </template>
        <template v-else>
          <Blank />
        </template>
      </div>
    </template>
    <el-divider />
    <template v-if='formMode === "search" || (!searchMode && (actionType === "1" || actionType === "8"))'>
    <div class="el-form--inline">
      <Callsign v-model="callsign" :searchCond="searchMode" :required="!searchMode" :disabled="editDisabledMode"/>
      <RouteCode v-model="routeCode" :searchCond="searchMode" :required="!searchMode" :disabled="editDisabledMode"/>
    </div>
    <div class="el-form--inline">
      <AirportCode v-model="departureAirportCode" label="出発地" prop="departure_airport_code" :searchCond="searchMode" :initialize="true" class = "departure_airport_code"
        :autocomplete-list="autocompleteAirportCodeSet" :disabled='(actionType === "8" && !searchMode) || editDisabledMode' :required="!searchMode"/>
      <AirportCode v-model="destinationAirportCode" label="目的地" prop="destination_airport_code" :searchCond="searchMode" :initialize="true" class = "destination_airport_code"
        :autocomplete-list="autocompleteAirportCodeSet" :disabled='(actionType === "1" && !searchMode) || editDisabledMode' :required="!searchMode"/>
    </div>
    <div class="el-form--inline">
      <FlightPurposeCode v-model="flightPurposeCode" label="飛行目的" :searchCond="searchMode" :disabled="editDisabledMode" :required="!searchMode"/>
      <FlightType v-model="flightType" :searchCond="searchMode" :initialize="true" :disabled="editDisabledMode" :required="!searchMode"/>
    </div>
    <div class="el-form--inline">
      <Irregular v-model="irregular" :searchCond="searchMode" :initialize="true" :disabled="editDisabledMode"/>
      <Blank />
    </div>
    <el-divider />
    </template>
    <div class="el-form--inline">
      <CustomerCode v-model="operatorCode" label="運航者" prop="operator_code" :required="!searchMode" :searchCond="searchMode"
        :autocomplete-list="autocompleteCustomerCodeSet" :disabled="editDisabledMode"/>
      <template v-if='formMode === "search" || editMode'>
        <BillToCode v-model="billToCode" :required="!searchMode" :searchCond="searchMode"
          :autocomplete-list="autocompleteCustomerCodeSet" :disabled="editDisabledMode"/>
      </template>
      <template v-else>
        <Blank />
      </template>
    </div>
    <template v-if='formMode === "search" || editMode'>
      <div class="el-form--inline">
        <ModelCode v-model="modelCode" :required="!searchMode" :searchCond="searchMode" :initialize="true"
          :autocomplete-list="autocompleteModelCodeSet" :disabled="editMode"/>
        <AircraftType v-model="aircraftType" :required="!searchMode" :searchCond="searchMode" :initialize="true" :disabled="editMode"/>
      </div>
      <template v-if='formMode === "search" '>
        <div class="el-form--inline">
          <!-- <Weight v-model="weight" label="重量" prop="weight" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode"/>
          <NoiseLevel v-model="noiseLevel" label="騒音値" prop="noise_level" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode"/> -->
          <Numeric v-model="weight" label="重量[t]" prop="weight" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode"
          :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
          <Numeric v-model="noiseLevel" label="騒音値[EPNdB]" prop="noise_level" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode"
          :min="0" :max="999" :precision="0" :step="1"/>
        </div>
      </template>
      <template v-else>
        <div class="el-form--inline">
          <Numeric v-model="weight" label="重量[t]" placeholder="0.1～999.9" prop="weight" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode"
          :min="0.1" :max="999.9" :precision="1" :step="0.1"/>
          <Numeric v-model="noiseLevel" label="騒音値[EPNdB]" placeholder="0～999" prop="noise_level" :required="!searchMode" :searchCond="searchMode" :disabled="editDisabledMode"
          :min="0" :max="999" :precision="0" :step="1"/>
        </div>
      </template>
    </template>
  </el-form>
</template>

<script>
import BillingYm from '@/components/molecules/form/select/BillingYm.vue'
import RegistrationSymbol from '@/components/molecules/form/autocomplete/RegistrationSymbol.vue'
import ActionType from '@/components/molecules/form/select/ActionType.vue'
import DateTimeRange from '@/components/molecules/form/date/DateTimeRange.vue'
import DateTime from '@/components/molecules/form/date/DateTime.vue'
import ModelCode from '@/components/molecules/form/autocomplete/ModelCode.vue'
import AircraftType from '@/components/molecules/form/select/AircraftType.vue'
import Numeric from '@/components/molecules/form/number/Numeric.vue'
// import Weight from '@/components/molecules/form/number/Weight.vue'
// import NoiseLevel from '@/components/molecules/form/number/NoiseLevel.vue'
import Callsign from '@/components/molecules/form/text/Callsign.vue'
import RouteCode from '@/components/molecules/form/select/RouteCode.vue'

import CustomerCode from '@/components/molecules/form/autocomplete/CustomerCode.vue'
import BillToCode from '@/components/molecules/form/autocomplete/BillToCode.vue'
import AirportCode from '@/components/molecules/form/autocomplete/AirportCode.vue'
import FlightPurposeCode from '@/components/molecules/form/select/FlightPurposeCode.vue'
import FlightType from '@/components/molecules/form/select/FlightType.vue'
import Irregular from '@/components/molecules/form/select/Irregular.vue'
import Blank from '@/components/molecules/form/text/Blank.vue'
// import UseDataStatus from '@/components/molecules/form/select/UseDataStatus.vue'
import BillingExclusion from '@/components/molecules/form/select/BillingExclusion.vue'

export default {
  components: {
    BillingYm,
    RegistrationSymbol,
    ActionType,
    DateTimeRange,
    DateTime,
    ModelCode,
    AircraftType,
    Numeric,
    // Weight,
    // NoiseLevel,
    Callsign,
    RouteCode,
    CustomerCode,
    BillToCode,
    AirportCode,
    FlightPurposeCode,
    FlightType,
    Irregular,
    Blank,
    // UseDataStatus
    BillingExclusion
  },
  model: {
    prop: 'model'
  },
  props: {
    model: Object,
    formMode: {
      type: String,
      default: 'search'
    },
    rules: Object,
    autocompleteRegistrationSymbolSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteModelCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteCustomerCodeSet: {
      type: Array,
      default: () => ([])
    },
    autocompleteAirportCodeSet: {
      type: Array,
      default: () => ([])
    },
    billingYmMode: {
      type: String,
      default: 'search'
    },
    editDisabledMode: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    billingYm: {
      get () {
        return this.model.billing_ym
      },
      set (billingYm) {
        const form = { ...this.model }
        form.billing_ym = billingYm
        this.$emit('input', form)
      }
    },
    registrationSymbol: {
      get () {
        return this.model.registration_symbol
      },
      set (registrationSymbol) {
        const form = { ...this.model }
        form.registration_symbol = registrationSymbol
        this.$emit('input', form)
      }
    },
    actionType: {
      get () {
        return this.model.action_type
      },
      set (actionType) {
        const form = { ...this.model }
        form.action_type = actionType
        this.$emit('input', form)

        if (!this.searchMode) {
          form.destination_airport_code = ''
          form.departure_airport_code = ''
          if (actionType === '1' || actionType === '8') {
            if (actionType === '1') {
              form.destination_airport_code = this.getDefaultOwnAirport()
            }
            if (actionType === '8') {
              form.departure_airport_code = this.getDefaultOwnAirport()
            }
          }
        }
      }
    },
    actionTime: {
      get () {
        return this.model.action_time
      },
      set (actionTime) {
        const form = { ...this.model }
        form.action_time = actionTime
        this.$emit('input', form)
      }
    },
    actionTimeFrom: {
      get () {
        return this.model.action_time_from
      },
      set (actionTimeFrom) {
        const form = { ...this.model }
        form.action_time_from = actionTimeFrom
        this.$emit('input', form)
      }
    },
    actionTimeTo: {
      get () {
        return this.model.action_time_to
      },
      set (actionTimeTo) {
        const form = { ...this.model }
        form.action_time_to = actionTimeTo
        this.$emit('input', form)
      }
    },
    modelCode: {
      get () {
        return this.model.model_code
      },
      set (modelCode) {
        const form = { ...this.model }
        form.model_code = modelCode
        this.$emit('input', form)
      }
    },
    aircraftType: {
      get () {
        return this.model.aircraft_type
      },
      set (aircraftType) {
        const form = { ...this.model }
        form.aircraft_type = aircraftType
        this.$emit('input', form)
      }
    },
    weight: {
      get () {
        return this.model.weight
      },
      set (weight) {
        const form = { ...this.model }
        form.weight = weight
        this.$emit('input', form)
      }
    },
    noiseLevel: {
      get () {
        return this.model.noise_level
      },
      set (noiseLevel) {
        const form = { ...this.model }
        form.noise_level = noiseLevel
        this.$emit('input', form)
      }
    },
    callsign: {
      get () {
        return this.model.callsign
      },
      set (callsign) {
        const form = { ...this.model }
        form.callsign = callsign
        this.$emit('input', form)
      }
    },
    routeCode: {
      get () {
        return this.model.route_code
      },
      set (routeCode) {
        const form = { ...this.model }
        form.route_code = routeCode
        this.$emit('input', form)
      }
    },
    operatorCode: {
      get () {
        return this.model.operator_code
      },
      set (operatorCode) {
        const form = { ...this.model }
        form.operator_code = operatorCode
        this.$emit('input', form)
      }
    },
    billToCode: {
      get () {
        return this.model.bill_to_code
      },
      set (billToCode) {
        const form = { ...this.model }
        form.bill_to_code = billToCode
        this.$emit('input', form)
      }
    },
    departureAirportCode: {
      get () {
        return this.model.departure_airport_code
      },
      set (departureAirportCode) {
        const form = { ...this.model }
        form.departure_airport_code = departureAirportCode
        this.$emit('input', form)
      }
    },
    destinationAirportCode: {
      get () {
        return this.model.destination_airport_code
      },
      set (destinationAirportCode) {
        const form = { ...this.model }
        form.destination_airport_code = destinationAirportCode
        this.$emit('input', form)
      }
    },
    flightPurposeCode: {
      get () {
        return this.model.flight_purpose_code
      },
      set (flightPurposeCode) {
        const form = { ...this.model }
        form.flight_purpose_code = flightPurposeCode
        this.$emit('input', form)
      }
    },
    flightType: {
      get () {
        return this.model.flight_type
      },
      set (flightType) {
        const form = { ...this.model }
        form.flight_type = flightType
        this.$emit('input', form)
      }
    },
    irregular: {
      get () {
        return this.model.irregular
      },
      set (irregular) {
        const form = { ...this.model }
        form.irregular = irregular
        this.$emit('input', form)
      }
    },
    // useDataStatus: {
    //   get () {
    //     return this.model.use_data_status
    //   },
    //   set (useDataStatus) {
    //     const form = { ...this.model }
    //     form.use_data_status = useDataStatus
    //     this.$emit('input', form)
    //   }
    // },
    errorDataOnly: {
      get () {
        return this.model.error_data_only
      },
      set (errorDataOnly) {
        const form = { ...this.model }
        form.error_data_only = errorDataOnly
        this.$emit('input', form)
      }
    },
    calculateAllData: {
      get () {
        return this.model.calculate_All_Data
      },
      set (calculateAllData) {
        const form = { ...this.model }
        form.calculate_All_Data = calculateAllData
        this.$emit('input', form)
      }
    },
    billingExclusionDataOnly: {
      get () {
        return this.model.billing_exclusion_data_only
      },
      set (billingExclusionDataOnly) {
        const form = { ...this.model }
        form.billing_exclusion_data_only = billingExclusionDataOnly
        this.$emit('input', form)
      }
    },
    updateDate: {
      get () {
        return this.model.updated_on
      },
      set (updateDate) {
        const form = { ...this.model }
        form.updated_on = updateDate
        this.$emit('input', form)
      }
    },
    searchMode: {
      get () {
        return this.formMode === 'search'
      }
    },
    editMode: {
      get () {
        return this.formMode === 'edit'
      }
    },
    billingExclusion: {
      get () {
        return this.model.billing_exclusion_flag
      },
      set (billingExclusion) {
        const form = { ...this.model }
        if (billingExclusion === '') { billingExclusion = undefined }
        form.billing_exclusion_flag = billingExclusion
        this.$emit('input', form)
      }
    }
  },
  methods: {
    changeActionType (sel) {
      // if (!this.searchMode) {
      const obj = document.getElementsByClassName('airport-code')
      for (var i = 0; i < obj.length; i++) {
        // 要素からclass="is-required"を削除する
        obj[i].classList.remove('is-required')
        if (!this.searchMode) {
          // if ((sel === '1' && i === 0) || (sel === '8' && i === 1)) {
          if ((sel === '1' && obj[i].className.match(/departure/)) || (sel === '8' && obj[i].className.match(/destination/))) {
            // 要素にclass="is-required"を追加する
            obj[i].classList.add('is-required')
          }
        }
      }
    },
    clearFields () {
      this.changeActionType(this.model.action_type)
      this.$refs.mergeDataForm.resetFields()
      this.model.billing_ym = this.getDefaultBillingYm()
      if (this.searchMode) {
        this.model.action_time_from = null
        this.model.action_time_to = null
        this.model.error_data_only = false
        this.model.calculate_All_Data = false
      }
    },
    validate () {
      return new Promise((resolve, reject) => {
        this.$refs.mergeDataForm.validate((valid) => {
          if (valid) {
            resolve(valid)
          } else {
            reject(new Error('validate error'))
          }
        })
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .parent_Box {
    position: absolute;
    top: 80px;
    right: 0px;
    width: calc((100% - (20px * 1)) / 2);
  }
</style>
